import { Link } from "@tanstack/react-router";
import { LogOut, MoreVertical, Settings, ShieldCheckIcon } from "lucide-react";
import { Avatar, AvatarImage } from "@/components/ui/avatar";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	useSidebar,
} from "@/components/ui/sidebar";
import { UserButton, useAuthActions, useUser } from "@/lib/auth-ui";
import { isSuperAdminUser } from "@/lib/super-admin";

export function NavUser() {
	const { isMobile } = useSidebar();
	const { user } = useUser();
	const { signOut } = useAuthActions();
	const isAdmin = isSuperAdminUser(user);

	return (
		<SidebarMenu>
			<SidebarMenuItem>
				<DropdownMenu>
					<DropdownMenuTrigger asChild>
						<SidebarMenuButton
							className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
							size="lg"
						>
							<UserButton />
							<div className="grid flex-1 text-left text-sm leading-tight">
								<span className="truncate font-medium">{user?.fullName}</span>
								<span className="truncate text-muted-foreground text-xs">
									{user?.emailAddresses[0].emailAddress}
								</span>
							</div>
							<MoreVertical className="ml-auto size-4" />
						</SidebarMenuButton>
					</DropdownMenuTrigger>
					<DropdownMenuContent
						align="end"
						className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
						side={isMobile ? "bottom" : "right"}
						sideOffset={4}
					>
						<DropdownMenuLabel className="p-0 font-normal">
							<div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
								<Avatar className="h-8 w-8 rounded-lg">
									<AvatarImage
										alt={user?.fullName ?? ""}
										src={user?.imageUrl ?? undefined}
									/>
								</Avatar>
								<div className="grid flex-1 text-left text-sm leading-tight">
									<span className="truncate font-medium">{user?.fullName}</span>
									<span className="truncate text-muted-foreground text-xs">
										{user?.emailAddresses[0].emailAddress}
									</span>
								</div>
							</div>
						</DropdownMenuLabel>
						<DropdownMenuSeparator />
						<DropdownMenuGroup>
							<DropdownMenuItem asChild>
								<Link to="/account/settings">
									<Settings className="mr-2 h-4 w-4" />
									Manage Account
								</Link>
							</DropdownMenuItem>
							{isAdmin && (
								<DropdownMenuItem asChild>
									<Link to="/admin">
										<ShieldCheckIcon className="mr-2 h-4 w-4" />
										Admin Dashboard
									</Link>
								</DropdownMenuItem>
							)}
						</DropdownMenuGroup>
						<DropdownMenuSeparator />
						<DropdownMenuItem onClick={() => signOut()}>
							<LogOut className="mr-2 h-4 w-4" />
							Log out
						</DropdownMenuItem>
					</DropdownMenuContent>
				</DropdownMenu>
			</SidebarMenuItem>
		</SidebarMenu>
	);
}
